<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'respostasRapidasCrud'"
          crudName="Respostas Rápidas"
          newText="Nova Resposta Rápida"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :with="'?with[]=departamento'"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
          <div slot="departamento" slot-scope="props">
            {{ props.row.departamento ? props.row.departamento.nome : "Global" }}
          </div>
          <div slot="status" slot-scope="props">
            <span v-if="props.row.status == 1" class="badge badge-success">Ativo</span>
            <span v-else class="badge badge-secondary">Inativo</span>
          </div>
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "respostasRapidasTable",
      columns: ["id", "atalho", "titulo", "departamento", "status", "actions"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          atalho: "Atalho",
          titulo: "Título",
          departamento: "Departamento",
          status: "Status",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";

          return axios.get(this.url + "&" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "respostas_rapidas/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        atalho: "atalho",
        titulo: "titulo",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>
